<template>
  <div v-if="!item.hidden" class="menu-item">
    <!-- 没有子菜单或只有一个子菜单 -->
    <template v-if="hasOneShowingChild(item.children, item)">
      <el-menu-item :index="resolvePath(onlyOneChild.path)">
        <el-icon v-if="onlyOneChild.meta?.icon">
          <component :is="onlyOneChild.meta.icon" />
        </el-icon>
        <template #title>
          <el-badge
            v-if="isCsSessionMenu(onlyOneChild) && csNotify.hasUnread"
            :value="csNotify.badgeText"
            type="danger"
            :max="99"
          >
            <span class="sidebar-menu-title">{{ onlyOneChild.meta?.title || onlyOneChild.menuName }}</span>
          </el-badge>
          <span v-else class="sidebar-menu-title">{{ onlyOneChild.meta?.title || onlyOneChild.menuName }}</span>
        </template>
      </el-menu-item>
    </template>

    <!-- 有多个子菜单 -->
    <el-sub-menu v-else :index="resolvePath(item.path)">
      <template #title>
        <el-icon v-if="item.meta?.icon">
          <component :is="item.meta.icon" />
        </el-icon>
        <el-badge
          v-if="isCsManageMenu(item) && csNotify.hasUnread"
          :value="csNotify.badgeText"
          type="danger"
          :max="99"
        >
          <span class="sidebar-menu-title">{{ item.meta?.title || item.menuName }}</span>
        </el-badge>
        <span v-else class="sidebar-menu-title">{{ item.meta?.title || item.menuName }}</span>
      </template>
      <sidebar-item
        v-for="child in visibleChildren"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(child.path)"
      />
    </el-sub-menu>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import { useCsNotifyStore } from '@/stores/cs-notify'

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const csNotify = useCsNotifyStore()

    const isCsSessionMenu = (node) => {
      if (!node) return false
      const p = node.path || ''
      const code = node.menuCode || ''
      return p === '/cs/session' || code === 'cs_session'
    }

    const isCsManageMenu = (node) => {
      if (!node) return false
      const p = node.path || ''
      const code = node.menuCode || ''
      return p === '/cs' || code === 'cs_manage'
    }

    const onlyOneChild = ref(null)
    const visibleChildren = computed(() => {
      return (props.item.children || []).filter(item => !item.hidden)
    })

    const hasOneShowingChild = (children = [], parent) => {
      const showingChildren = children.filter(item => !item.hidden)

      // 没有子菜单，显示父菜单本身
      if (showingChildren.length === 0) {
        onlyOneChild.value = { ...parent, noShowingChildren: true }
        return true
      }

      // 只有一个子菜单
      if (showingChildren.length === 1) {
        onlyOneChild.value = showingChildren[0]
        return true
      }

      return false
    }

    const resolvePath = (routePath) => {
      if (!routePath) return props.basePath || ''
      return routePath
    }

    return {
      csNotify,
      isCsSessionMenu,
      isCsManageMenu,
      onlyOneChild,
      hasOneShowingChild,
      resolvePath,
      visibleChildren
    }
  }
}
</script>
